import { Text } from '@blueprintjs/core'
import { Link } from '@inertiajs/react'
import { CURRENCY_SIGN } from 'lib/constants/currency'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type TProps = {
  order: Data.Order
}

const OrderCard: FC<TProps> = ({ order }) => {
  const { t } = useTranslation(ClientLocaleNS.ProfilePage)
  const date = new Date(order.created_at * 1000).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
  return (
    <Link href={`/profile/payments/${order.id}`} className="flex no-underline hover:no-underline focus:outline-none">
      <div className="flex flex-col w-full gap-1 border border-solid border-palette-blue rounded-md p-2 text-palette-black hover:text-palette-white hover:bg-palette-blue transition-colors cursor-pointer">
        <Text tagName="span" className="font-body---14px">
          {t('payments.order_id', { id: order.id })}
        </Text>
        <Text tagName="span" className="font-body---14px">
          {t('payments.count', { count: order.orderables.length })}
        </Text>
        <Text tagName="span" className="font-body---16px">
          {t('payments.value', { currency_sign: CURRENCY_SIGN, value: order.total })}
        </Text>
        <Text tagName="span" className="font-body---14px text-palette-grey--alt">
          {t('payments.date', { date })}
        </Text>
      </div>
    </Link>
  )
}

export { OrderCard }
